import React, { useState } from 'react';
import PropTypes from 'prop-types';

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
  },
  modal: {
    backgroundColor: '#fff',
    borderRadius: '10px',
    padding: '30px 25px',
    width: '90%',
    maxWidth: '420px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.3)',
    textAlign: 'center',
    position: 'relative',
  },
  title: {
    fontSize: '20px',
    marginBottom: '12px',
    fontWeight: 'bold',
    color: '#333',
  },
  text: {
    fontSize: '16px',
    margin: '10px 0',
    color: '#555',
  },
  button: {
    marginTop: '20px',
    backgroundColor: '#2f80ed',
    color: '#fff',
    border: 'none',
    borderRadius: '5px',
    padding: '10px 18px',
    fontSize: '16px',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
  },
  closeButton: {
    position: 'absolute',
    top: '10px',
    right: '12px',
    background: 'transparent',
    border: 'none',
    fontSize: '20px',
    color: '#999',
    cursor: 'pointer',
  },
};

const RedirectUsersModal = (props) => {
  const [open, setOpen] = useState(true);
  const lock = props?.lock || false;

  const handleRedirect = () => {
    window.open('https://recruteur.monspecialisteauto.com', '_blank', 'noopener,noreferrer');
  };

  if (!open) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        {!lock && (
          <button style={styles.closeButton} onClick={() => setOpen(false)}>
            ✕
          </button>
        )}

        <h2 style={styles.title}>Pour votre information</h2>
        <p style={styles.text}>
          Cette version de la plateforme MSA ne permet plus la gestion du service MSA Staff. Pour suivre l’avancement de vos prestations ou en créer de nouvelles, veuillez utiliser
          la nouvelle plateforme MSA ci-dessous.
        </p>
        <button style={styles.button} onClick={handleRedirect}>
          Aller vers la nouvelle plateforme MSA
        </button>
      </div>
    </div>
  );
};

RedirectUsersModal.propTypes = {
  lock: PropTypes.bool,
};

export default RedirectUsersModal;
